import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import Modal from 'react-modal';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import DialogContainer from './Dialogs/DialogContainer';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import MembershipForm from './MembershipForm.js';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import GridDateLocaleDateFormatter from '../../../GridDateLocaleDateFormatter';
import GridNumberFormatter from '../../../GridNumberFormatter';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { MembershipsLoader } from './MembershipsLoader';
import { auth } from '../../../../../services/auth.service';

const FileDownload = require('js-file-download');

export class ManageMemberships extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            membershipInEdit: {},
            isPopupVisible: false,
            memberships: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "memberNumber", dir: "desc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: "",
            isAdmin: false,
        };
    }

    componentDidMount() {
        this.setPermission();
    }

    setPermission() {
        var permissions = auth.getPermissions();
        return permissions.find((element) => {
            if (element.value === "Admin") {
                this.setState({
                    isAdmin: true,
                });
            }
        });
    }

    dataStateChange = (e) => {

        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && filters[i].field == "membershipExpirationDate") {
                    var operator = filters[i].operator;

                    if ((operator == "gt" || operator == "gte") && !filters[i].value) {

                        filters[i].value = new Date('January 01, 1900');

                    } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

                        var currentDatetime = new Date();

                        filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

                    }
                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (membershipsFetched) => {
        this.setState({
            ...this.state,
            memberships: membershipsFetched,
            isLoading: false
        });

        if (membershipsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (membershipsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        if (dataItem.transactionId) {
            dataItem.transactionId = Number(dataItem.transactionId);
        } else {
            dataItem.transactionId = 0;
        }

        this.setState({
            membershipInEdit: this.cloneMembership(dataItem) ,
            isPopupVisible: true
        });
    };
    cloneMembership(event) {
        var t = Object.assign({}, event);
        let membershipType = {
            membershipTypeID: event.membershipTypeId || 0,
            description: event.membershipType || ''
        };
        let membershipPackage = {
            membershipPackageID: event.membershipPackageId || 0,
            description: event.membershipPackage || '',
            cost: event.membershipPackageCost,
            membershipTypeID: event.membershipTypeId || 0,
            additionalMemberships: event.additionalMemberships
        };
        let state = {
            id: event.mailingStateId || 0,
            name: event.state || ''
        };
        let countyObj = {
            countyId: event.mailingCountyId || 0,
            countyName: event.county || ''
        }

        t['county'] = countyObj;
        t['state'] = state;
        t['membershipPackage'] = membershipPackage;
        t['membershipPackageId'] = membershipPackage.membershipPackageID;
        t['membershipType'] = membershipType;
        t['membershipTypeID'] = membershipType.membershipTypeID;
        t['mailingAddress1'] = event.address1;
        return t;
    }

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                if (element["field"] == "OrderDate") {
                    let date = element.value;
                    if (!date) {
                        date = "01/01/0001";
                    }
                    else {
                        date = (date + '').split(" ");
                        let day = date[2] + '';
                        let year = date[3] + '';
                        let month = "01";
                        switch (date[1]) {
                            case "Jan":
                                month = "01";
                                break;
                            case "Feb":
                                month = "02";
                                break;
                            case "Mar":
                                month = "03";
                                break;
                            case "Apr":
                                month = "04";
                                break;
                            case "May":
                                month = "05";
                                break;
                            case "Jun":
                                month = "06";
                                break;
                            case "Jul":
                                month = "07";
                                break;
                            case "Aug":
                                month = "08";
                                break;
                            case "Sep":
                                month = "09";
                                break;
                            case "Oct":
                                month = "10";
                                break;
                            case "Nov":
                                month = "11";
                                break;
                            case "Dec":
                                month = "12";
                                break;
                        }
                        date = month + "/" + day + "/" + year;
                        element["value"] = date;
                    }
                }
                else {
                    for (var key in t[i]) {
                        element[key] = element[key] + '';
                    }
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : [],
            isAdmin: this.state.isAdmin,
        }

        axios.get(ROOT_API_URL + "/ManageMembership/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Memberships.csv');
                this.setState({
                    alertVisible: false,
                    alertMessage: ''
                });
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: []
            },
        });

        var url = `${ROOT_API_URL}/ManageMembership/SaveAdminMembership`;
        const options = { method: 'POST', headers: auth.authHeader() };

        axios
            .post(url, model, options)
            .then((response) => {
                this.setState({
                    isSubmitted: false,
                    alertVisible: false,
                    alertMessage: ''
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the membership.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }
    toggleActive = (dataItem) => {
       
        dataItem.isActive = !dataItem.isActive;
        var model = {IsActive:dataItem.isActive,Id:dataItem.membershipId}
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "memberNumber", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageMembership/DeleteMembership`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false,
                    alertVisible: false,
                    alertMessage: ''
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the membership.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }
    render() {
        return (
            <div id={"memberhips-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading memberships" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.memberships.total}
                                {...this.state.dataState}
                                {...this.state.memberships}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageMembership/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="memberNumberInt" title="Member #" filter="numeric" />
                                {/* <Column field="transactionId" title="Transaction Id" filter="text" /> */}
                                <Column field="organizationName" title="Organization" filter="text" />
                                <Column field="firstName" title="First Name" filter="text" />
                                <Column field="lastName" title="Last Name" filter="text" />
                                <Column field="phone" title="Phone" filter="text" />
                                <Column field="email" title="Email" />
                                {/*<Column field="address1" title="Address" filter="text" />*/}
                                <Column field="membershipTypeName" title="Type" filter="text" />
                                <Column field="cattleCount" title="Package" filter="text" />
                                <Column field="membershipStatus" title="Status" filter="text" />
                                <Column field="membershipExpirationDate" title="Expiration Date" width="120vw" cell={GridDateLocaleDateFormatter} filter="date" />
                                <Column field="county" title="County" filter="text" />
                                {/*<Column field="daysExpired" title="Days Since Expiration" filter="text" />*/}
                                <Column field="additionalMemberships" title="Additional Memberships" width="110vw" filter="text" />
                                <Column field="remainingMemberships" title="Remaining Memberships " width="110vw" filter="text" />
                                {this.state.isAdmin && <Column field="autoRenew" title="Auto Renew " width="110vw" filter="text" />}
                                {/*<Column field="referredBy" title="Referred By" filter="text" />*/}
                                {/* <Column
								field="isActive"
								title="Active Membership"
								width="60vw"
								filterable={false}
								className="isActive-column"
							/>*/}
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <MembershipsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    <Modal
                        isOpen={this.state.isPopupVisible}
                        onRequestClose={this.cancel}
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                marginRight: '-50%',
                                minWidth: '80vw',
                                maxWidth: '80vw',
                                minHeight: '80vh',
                                maxHeight: '80vh',
                                overflow: 'auto',
                                transform: 'translate(-50%, -50%)',
                                borderRadius: '5px'
                            }
                        }}
                    >
                        <DialogContainer
                            dataItem={this.state.membershipInEdit}
                            save={this.save}
                            cancel={this.cancel}
                            saveAdminMembership={this.props.saveMembership}
                        />
                    </Modal>
                </div>
            </div>

        );
    }
}

export default ManageMemberships;